var map = {
	"./badge_filter.png": "7d0a",
	"./badge_graph.png": "9854",
	"./badge_video.png": "500d",
	"./circled-pause.png": "29ad",
	"./circled-play.png": "588f",
	"./download.png": "fa8b",
	"./fast-forward.png": "3aa1",
	"./forward-5.png": "57dd",
	"./hide.png": "c6f0",
	"./icons8-circled-play-x1-100 copie.png": "f728",
	"./icons8-circled-play-x1-25_true.png": "5c3d",
	"./icons8-circled-play-x2-100.png": "6414",
	"./icons8-circled-play-x2-25_false.png": "f540",
	"./logo.png": "e0dd",
	"./ok.png": "5ffe",
	"./open_pane.png": "0fb7",
	"./question-mark.png": "bbd5",
	"./reduce.png": "e1d6",
	"./replay-5.png": "6ffe",
	"./replay.png": "50ee",
	"./show.png": "36e7",
	"./speed1.png": "0b5b",
	"./speed10.png": "fd14",
	"./speed2.png": "c9c8",
	"./stop-circled.png": "7e87",
	"./unavailable.png": "66da",
	"./zoom.png": "18c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "61b0";